

























































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import XLSX from 'xlsx';
import Combobox from "@/components/Controls/Combobox.vue";
import ExcelJS from "exceljs";

@Component({
  computed: {
    ...mapGetters(STORE_KEY, ['total']),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'data', 'documents'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    Combobox,
    TitleBar
  }
})
export default class LossesReport extends Vue {
  sortingPriority: any[] = [{"field": "shift_date","order": "asc"}];

  get titleStack () {
    return [
      'Отчеты',
      'По потерям АТОМ'
    ]
  }

  columnsList: any[] = [
    {id: 'shift_date', label: 'Дата производства'},
    {id: 'times_of_day', label: 'День/ночь'},
    {id: 'manager_name', label: 'Мастер смены'},
    {id: 'operator_name', label: 'Оператор'},
    {id: 'number', label: '№ партии'},
    {id: 'product_name', label: 'Этикетка на ведре'},
    {id: 'clots_weight', label: 'Вес нетто загрузки, кг'},
    {id: 'fact_weight', label: 'Фактический выход нетто, кг'},
    {id: 'deviant_over', label: 'Количественные отклонения (Перерасход) продукта, кг'},
    {id: 'deviant_sur', label: 'Количественные отклонения (Излишки) продукта, кг'},
    {id: 'loss_rate', label: '"Нормы потерь, %'},
    {id: 'deviant_over_precent', label: 'Количественные отклонения (Перерасход) продукта (включая норму потерь), %'},
    {id: 'deviant_sur_precent', label: 'Количественные отклонения (Излишки) продукта (включая норму потерь), %'},
  ]
  showColumns: any[] = []

  localFilter = {
    employeeId: null,
    targetDates: [new Date(), new Date()],
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.employeeId = (this.$route.query && this.$route.query.employeeId)? this.$route.query.employeeId : null;
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];

    this.handleParamsChange();

    this.showColumns = this.columnsList.map((col: any) => {
      return col.id;
    });
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }
  tableToExcel(no_products: boolean = false) {
    this.$store.dispatch(`${STORE_KEY}/exportData`, {columns: this.showColumns, columnsList: this.columnsList}).then((data: any) => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Отчет')
      const _col_width: any = {
        'shift_date': 20,
        'manager_name': 50,
        'operator_name': 50,
        'product_name': 50,
      }      
      const _col_colors: any = {
        'clot-ok': ['B0F2BC', '000000'],
        'clot-middle': ['FFD966', '000000'],
        'clot-warn': ['FF5050', 'FFFFFF'],
      }

      console.log(data.colors)

      data.csvContent.forEach((row: any, idx: number) => {
        const _row: any = worksheet.addRow(row)

        _row.eachCell({ includeEmpty: true }, (cell: any, colNumber: number) => {
          const col_key = this.showColumns[colNumber - 1]
          
          if (colNumber >= 7 && idx > 0) {
            cell.value = cell.value ? `${(cell.value * 100) / 100}`.replace('.', ',') : cell.value
            cell.numFmt = '#,##0.00'

            cell.alignment = { vertical: 'middle', horizontal: 'center' };
          }
          if (idx < 2) {
            cell.style.font = {
              size: 11,
              bold: true
            }
          }
          if (data.colors[idx - 2] && data.colors[idx - 2][col_key]) {
            cell.font = {
              color: {
                argb: _col_colors[data.colors[idx - 2][col_key]][1]
              },
            };
            cell.fill = {
              type: 'pattern', 
              pattern: 'solid', 
              fgColor: {
                argb: _col_colors[data.colors[idx - 2][col_key]][0]
              }
            }
          }
        });
      })

      this.showColumns.map((item: any, idx: number) => {
        worksheet.getColumn(idx + 1).width = _col_width[item] ? _col_width[item] : 15
      })
      workbook.xlsx.writeBuffer()
      .then( function (xls64: any) {
          const a = document.createElement("a");
          const data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const url = URL.createObjectURL(data);
          a.href = url;
          a.download = "export.xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
          },
          0);
      })
      .catch(function(error: any) {
          console.log(error.message);
      });
    })
  }

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
